import React, { useState, useEffect, useMemo } from 'react'
import Grid from '@mui/material/Grid2'
import { Button, Box, Typography, Divider, TextField } from '@mui/material'
import { styled } from '@mui/material/styles'
import Stack from '@mui/material/Stack'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { MantineReactTable } from 'mantine-react-table'
import excel_img from '../../asset/excel_img.png'
import { data, data2 } from './makeData'
import AccountBoxIcon from '@mui/icons-material/AccountBox'
import person1 from '../../asset/person1.png'
import person2 from '../../asset/person2.png'
import Api from '../../Api/Api'
import { v4 as uuidv4 } from 'uuid'
import secureLocalStorage from 'react-secure-storage'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import Checkbox from '@mui/material/Checkbox'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import Loader from '../../Components/Loading'
import workerIN_worker_1 from '../../asset/workerIN_worker_1.png'
import ExportToExcel from '../../Components/ExportToExcel'

const styles1 = {
  grid1: {
    padding: 4,
    background: '#2C2D33',
    borderRadius: '10px',
    border: '1px solid #afafaf',
    borderImageSlice: 1,
    borderImage:
      'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
  Typography1: {
    color: '#ffffff',
    fontFamily: 'Noto Sans KR',
    fontSize: '22px',
    fontWeight: 700,
    lineHeight: '28.96px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography2: {
    color: '#D2D2D2',
    fontFamily: 'Noto Sans KR',
    fontSize: '19px',
    fontWeight: 700,
    lineHeight: '18.82px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Typography3: {
    color: '#D2D2D2',
    fontFamily: 'Noto Sans KR',
    fontSize: '15px',
    fontWeight: 300,
    lineHeight: '15.82px',
    textAlign: 'left',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
  },
  Select1: {
    '& label': {
      color: '#e4e4e7',
    },
    '& label.Mui-focused': {
      width: 200,
      color: '#e4e4e7',
    },
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      opacity: 0.8,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },
    '& .MuiSvgIcon-root': {
      color: '#ffffff',
    },
    '& .MuiInputBase-input': {
      color: '#ffffff',
    },
    '&:hover .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },

    color: '#ffffff',
    backdropFilter: 'blur(53px)',
    boxShadow: '-8px 4px 5px 0px #0000003d',
    background: '#171821',
    // border: '1px solid #afafaf',
    // borderImageSource:
    //   'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
  TableCellHeader1: {
    background: '#D9D9D9',
    color: '#022022',
    borderBottom: '1px solid #CCCCCC',
  },
}
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein }
}

const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
]

export default function WorkerIN() {
  const loginId = secureLocalStorage.getItem('loginId')
  const [loadingFlag, setLoadingFlag] = useState(false)
  const [JobList, setJobList] = useState([])
  const [JobList2, setJobList2] = useState([])
  const [inputDeviceList, setInputDeviceList] = useState([])
  const [inputDeviceList2, setInputDeviceList2] = useState([])

  const [inputObjectList, setInputObjectList] = useState([{ ji: '', wname: '' }])
  const [rowSelection, setRowSelection] = React.useState({})

  const [inputModifyObjectList, setInputModifyObjectList] = useState([])

  const columns = React.useMemo(
    () => [
      {
        accessorKey: 'jn',
        header: '작업명',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'sdt',
        header: '작업시작시간',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'edt',
        header: '작업종료시간',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'lon',
        header: '시설이름',
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'orglists',
        header: '상세위치',
        Cell: ({ cell }) =>
          cell.getValue()?.map((item, index) => (cell.getValue().length - 1 === index ? `${item}` : `${item}> `)),
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
      {
        accessorKey: 'wkl',
        header: '투입인원수',
        Cell: ({ cell }) => `${cell.getValue().length}`,
        Header: ({ column }) => <div style={{ color: '#ffffff' }}>{column.columnDef.header}</div>,
      },
    ],
    []
  )

  React.useEffect(() => {
    //do something when the row selection changes...
    console.log('rowSelection:', rowSelection)

    let arr = Object.keys(rowSelection)
    console.log('arr:', arr)
    console.info({ rowSelection })
  }, [rowSelection])

  useEffect(() => {
    jobListFun()
  }, [])

  useEffect(() => {
    console.log('useEffect JobList:', JobList)
  }, [JobList])

  const handleInputDeviceList = (event, param) => {
    const {
      target: { value },
    } = event
    console.log('handleInputDeviceList value:', value)

    let copyList = [...inputObjectList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.ji === param.ji
    })
    copyList[find1].deviceLists = typeof value === 'string' ? value.split(',') : value

    setInputObjectList(copyList)
    setInputDeviceList(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    )
    console.log('handleInputDeviceList values:', value)
    console.log('handleInputDeviceList param:', param)
    console.log('handleInputDeviceList copyList:', copyList)
  }

  const handleInputDeviceList2 = (event, param) => {
    const {
      target: { value },
    } = event
    console.log('handleInputDeviceList2 value:', value)

    let copyList = [...inputModifyObjectList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.wid === param.workerId
    })
    copyList[find1].wdvs = typeof value === 'string' ? value.split(',') : value

    setInputModifyObjectList(copyList)
    setInputDeviceList2(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    )
    console.log('handleInputDeviceList2 values:', value)
    console.log('handleInputDeviceList2 param:', param)
    console.log('handleInputDeviceList2 copyList:', copyList)
  }

  const handelInputWorkerName = (e, param) => {
    let copyState = [...inputObjectList]
    console.log('handelInputWorkerName copyState:', copyState)

    const values = e.target.value
    console.log('handelInputWorkerName e:', e)
    console.log('handelInputWorkerName param:', param)

    const find1 = inputObjectList.findIndex((element, index, array) => {
      return element.ji === param.ji
    })
    copyState[find1].ji = param.ji
    copyState[find1].wname = values

    setInputObjectList(copyState)
  }
  // 수정mark
  const handelInputWorkerName2 = (e, param) => {
    let copyState = [...inputModifyObjectList]

    const values = e.target.value
    console.log('handelInputWorkerName2 param:', param)

    const find1 = copyState.findIndex((element, index, array) => {
      return element.wid === param.workerId
    })
    copyState[find1].wname = values
    console.log('handelInputWorkerName2 find1:', find1)
    console.log('handelInputWorkerName2 values:', values)
    console.log('handelInputWorkerName2 copyState:', copyState)
    setInputModifyObjectList(copyState)
  }

  const validationCheck = (param) => {
    if (param !== undefined && param !== null && param !== '') {
      return true
    } else {
      return false
    }
  }

  //작업 리스트
  const jobListFun = async () => {
    // setInputObjectList([])
    setLoadingFlag(true)
    try {
      // const response = await Api.get('api/v1/job/')
      const response = await Api.get('/api/v1/job/get_job_lists/works')

      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      let copyState = []
      if (response.status === 200) {
        // setJobList(response.data)
        copyState = response.data

        await copyState.map(async (item1, index) => {
          const tempDeviceList = await getDeviceListloid(item1.orgid, item1.loid)
          item1.deviceLists = tempDeviceList
        })
        setLoadingFlag(false)
        setJobList(copyState)
        setInputObjectList(
          response.data.map((star) => {
            return {
              ji: star.ji,
              wname: '',
              deviceLists: [],
            }
          })
        )
      }
      console.log('jobListFun response.data', response.data)
      console.log('jobListFun JobList', JobList)
      console.log('jobListFun copyState', copyState)
    } catch (e) {
      setLoadingFlag(false)
      console.log('jobListFun exception', e)
    }
  }
  // mark
  const addWorker = async (param) => {
    const uuid = uuidv4()
    const result = uuid.split('-')
    const findIndex = findInList(param)

    //url:api/v1/workers
    const addObject = {
      wid: result[0],
      wname: inputObjectList[findIndex].wname,
      ji: param.ji,
      loid: param.loid,
      uid: loginId,
      wdvs: inputObjectList[findIndex].deviceLists,
    }

    console.log('addWorker param:', param)
    console.log('addWorker addObject:', addObject)
    console.log('addWorker deviceList:', inputObjectList[findIndex].deviceLists)
    if (validationCheck(inputObjectList[findIndex].wname) && validationCheck(inputObjectList[findIndex].deviceLists)) {
      try {
        const response = await Api.post(`/api/v1/workers/`, addObject)
        if (response.status === 200) {
          let copyState = [...inputObjectList]
          copyState[findIndex].wname = ''
          copyState[findIndex].deviceLists = []
          setInputObjectList(copyState)
          console.log('addWorker copyState:', copyState)
          jobListFun()
          alert('근로자 등록됨')
        }
        // console.log('getDeviceListckNet response.data:', response.data)
      } catch (e) {
        alert(`근로자 등록 실패 ${e}`)
        console.log('addWorker exception', e)
      }
    } else {
      alert('빈칸이 있습니다.')
    }
  }

  const addWorkerFlagTrue = (param) => {
    const regedDeviceCount = param.deviceLists.length

    console.log('addWorkerFlag param:', param)
    console.log('addWorkerFlag regedDeviceCount:', regedDeviceCount)
    if (regedDeviceCount > 0) {
      let copyList = [...JobList]
      const find1 = copyList.findIndex((element, index, array) => {
        return element.ji === param.ji
      })
      copyList[find1].isFlag = true

      setJobList(copyList)
      console.log('addWorkerFlag JobList:', JobList)
    } else {
      alert('해당 시설에 등록된 장비가 없습니다. 먼저 해당시설에 사용될 장비를 등록해 주세요')
    }
  }

  const addWorkerFlagFalse = (param) => {
    console.log('addWorkerFlagFalse param:', param)
    let copyList = [...JobList]
    const findIndex = findInList(param)

    const find1 = copyList.findIndex((element, index, array) => {
      return element.ji === param.ji
    })
    copyList[find1].isFlag = false
    setJobList(copyList)

    let copyState = [...inputObjectList]
    console.log('addWorkerFlagFalse copyState1:', copyState)

    copyState[findIndex].wname = ''
    copyState[findIndex].deviceLists = []
    setInputObjectList(copyState)

    console.log('addWorkerFlagFalse copyState2:', copyState)
    console.log('addWorkerFlagFalse JobList:', JobList)
  }

  function findInList(param) {
    let copyState = [...inputObjectList]

    console.log('findInList copyState:', copyState)
    const find1 = copyState.findIndex((element, index, array) => {
      return element.ji === param.ji
    })
    // console.log('find1:', find1)
    return find1
  }

  function findInList2(param) {
    let copyState = [...inputModifyObjectList]
    console.log('findInList2 param:', param)
    console.log('findInList2 copyState:', copyState)
    const find1 = copyState.findIndex((element, index, array) => {
      return element.wid === param.workerId
    })
    // console.log('find1:', find1)
    return find1
  }

  function findInList3(param) {
    let copyState = [...inputModifyObjectList]
    console.log('findInList3 param:', param)
    console.log('findInList3 copyState:', copyState)
    const find1 = copyState.findIndex((element, index, array) => {
      return element.wid === param.workerId
    })
    // console.log('find1:', find1)
    return find1
  }

  const getDeviceListloid = async (p1, p2) => {
    console.log('getDeviceListloid p1,p2:', p1, p2)

    try {
      const response = await Api.get(`api/v1/devices/?ckNetDevice=false&orgid=${p1}&loid=${p2}`)
      if (response.status === 200) {
        console.log('getDeviceListloid response.data1:', response.data)
        return response.data
      }
    } catch (e) {
      console.log('getDeviceListloid exception', e)
    }
  }

  const deleteWorker = async (p1, p2) => {
    console.log('deleteWorker p1:', p1)
    console.log('deleteWorker p2:', p2)
    console.log(`api/v1/workers/${p1.workerId}?job_id=${p2.ji}`)

    try {
      const response = await Api.delete(`api/v1/workers/${p1.workerId}?job_id=${p2.ji}`)
      if (response.status === 200) {
        alert('근로자 삭제 성공')
        jobListFun()
      }
      console.log('deleteWorker response.data1:', response.data)
    } catch (e) {
      alert('근로자 삭제 실패')
      console.log('deleteWorker exception', e)
    }
  }

  // mark
  const patchWorker = async (p1) => {
    console.log('patchWorker p1:', p1)
    // p1.workerId
    let copyList = inputModifyObjectList
    const find1 = copyList.findIndex((element, index, array) => {
      return element.wid === p1.workerId
    })
    copyList[find1].uid = loginId

    console.log('patchWorker inputModifyObjectList[find1]:', copyList[find1])

    // const patchObject = {
    //   wname: '수정테',
    //   ji: p2.ji,
    //   uid: loginId,
    //   loid: p2.loid,
    //   wdvs: ['E8_07_BF_08_B3_99', '7857a222d2e4cd40'],
    // }

    try {
      const response = await Api.patch(`api/v1/workers/${p1.workerId}`, copyList[find1])
      if (response.status === 200) {
        alert('근로자 수정 성공')
        setInputModifyObjectList([])
        jobListFun()
      }
      console.log('patchWorker response.data1:', response.data)
    } catch (e) {
      alert(`근로자 수정 실패 ${e}`)
      console.log('patchWorker exception', e)
    }
  }

  const modifyWorkerFlagTrue = (p1, p2) => {
    console.log('modifyWorkerFlagTrue p1:', p1)
    console.log('modifyWorkerFlagTrue p2:', p2)

    let copyList = [...JobList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.ji === p2.ji
    })
    const find2 = copyList[find1].wkl.findIndex((element, index, array) => {
      return element.workerId === p1.workerId
    })
    copyList[find1].wkl[find2].isFlag = true
    setJobList(copyList)
    console.log('modifyWorkerFlagTrue JobList:', JobList)

    let copyList2 = [...inputModifyObjectList]
    const find3 = copyList2.findIndex((element, index, array) => {
      return element.ji === p2.ji && element.wid === p1.workerId
    })
    if (find3 < 0) {
      let tempWdsvList = []
      p1.deviceLists.map((item) => {
        tempWdsvList.push(item.device_id)
      })
      const tempObject = {
        wid: p1.workerId,
        wname: p1.workerName,
        ji: p2.ji,
        loid: p2.loid,
        wdvs: tempWdsvList,
      }
      copyList2.push(tempObject)
    }
    console.log('modifyWorkerFlagTrue copyList2:', copyList2)
    setInputModifyObjectList(copyList2)
  }

  const modifyWorkerFlagFalse = (p1, p2) => {
    console.log('modifyWorkerFlagFalse p1:', p1)
    console.log('modifyWorkerFlagFalse p2:', p2)
    let copyList = [...JobList]
    const find1 = copyList.findIndex((element, index, array) => {
      return element.ji === p2.ji
    })
    const find2 = copyList[find1].wkl.findIndex((element, index, array) => {
      return element.workerId === p1.workerId
    })
    copyList[find1].wkl[find2].isFlag = false
    setJobList(copyList)
    console.log('modifyWorkerFlagFalse JobList:', JobList)

    let copyList2 = [...inputModifyObjectList]
    const find3 = copyList2.findIndex((element, index, array) => {
      return element.ji === p2.ji && element.wid === p1.workerId
    })
    console.log('modifyWorkerFlagTrue find3:', find3)

    if (find3 > -1) {
      let tempList = copyList2.splice(find3, 1)
      console.log('modifyWorkerFlagTrue copyList2:', copyList2)
      setInputModifyObjectList(copyList2)
    }
  }

  const workInput = async () => {
    let arr = Object.keys(rowSelection)
    let result_list = []
    console.log('workInput arr:', arr)
    if (arr.length > 0) {
      arr.map((item) => {
        const find1 = JobList.findIndex((element, index, array) => {
          return element.ji === item
        })
        if (JobList[find1].wkl.length <= 0) {
          alert(`${JobList[find1].jn} 작업에 등록된 근로자가 없습니다`)
        } else {
          result_list.push(item)
        }
      })
      if (result_list.length > 0) {
        try {
          console.log('workInput result_list:', result_list)
          const response = await Api.post(`/api/v1/job/update_wkl_in_job/stdt`, result_list)
          if (response.status === 200) {
            alert('작업투입 성공')
            jobListFun()
            setRowSelection({})
          }
          if (response.status === 403) {
            alert('이미 작업투입 등록한 근로자가 있습니다.')
          }
          console.log('workInput response.data1:', response.data)
        } catch (e) {
          if (e.status === 403) {
            alert('이미 작업투입 등록한 근로자가 있습니다.')
          } else {
            alert(`작업투입 실패 ${e}`)
          }

          console.log('workInput exception', e)
        }
      }
    } else {
      alert('선택된 작업이 없습니다.')
    }
  }

  // mark
  return (
    <div style={{ padding: 17 }}>
      <Grid container sx={{ marginLeft: 3, marginRight: 3 }}>
        <Grid size={12} sx={styles1.grid1}>
          <Grid container>
            <Grid
              size={12}
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              <Typography sx={[styles1.Typography1]}>근로자 작업 투입 등록</Typography>
            </Grid>
            <Grid
              size={12}
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              <Typography sx={[styles1.Typography2, { marginTop: 1, marginLeft: 2 }]}>작업 투입전 준비사항</Typography>
            </Grid>
            <Grid size={12}>
              <Typography sx={[styles1.Typography3, { marginTop: 1, marginLeft: 4 }]}>
                1.작업 목록에서 투입하는 작업 선택
              </Typography>
              <Typography sx={[styles1.Typography3, { marginTop: 1, marginLeft: 4 }]}>
                2.투입 인원별 정보 입력→ 착용장비 목록을 확인하고 장비 선택
              </Typography>
              <Typography sx={[styles1.Typography3, { marginTop: 1, marginLeft: 4 }]}>3.작업시작 버튼 클릭</Typography>
            </Grid>
            <Grid size={12}></Grid>
          </Grid>
        </Grid>
        {/* <Grid size={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 5 }}>
          <Typography sx={styles1.Typography1}>작업목록</Typography>
        </Grid> */}
        <Grid size={12} sx={{ marginTop: 5 }}>
          {' '}
          <Box>
            <Grid container sx={{ marginBottom: 2 }}>
              <Grid
                size={6}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                <Typography sx={styles1.Typography1}>작업목록</Typography>
              </Grid>
              <Grid
                size={6}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                }}
              >
                {/* <Button variant="contained" sx={{ color: '#ffffff', background: '#454546', marginRight: 3 }}>
                  <DeleteOutlineIcon />
                  선택 삭제
                </Button> */}
                <ExportToExcel data={JobList} fileName={`작업투입목록`} />
              </Grid>
            </Grid>
            {loadingFlag === true ? (
              <Loader loading={loadingFlag} />
            ) : (
              // mark
              <>
                <MantineReactTable
                  getRowId={(row) => row.ji}
                  onRowSelectionChange={setRowSelection}
                  state={{ rowSelection }}
                  selectDisplayMode="checkbox"
                  enableRowSelection={true}
                  enableMultiRowSelection={true}
                  enableColumnActions={false}
                  enableColumnFilters={false}
                  enablePagination={true}
                  enableSorting={false}
                  columns={columns}
                  data={JobList}
                  enableFullScreenToggle={false}
                  paginationDisplayMode="pages"
                  renderDetailPanel={({ row }) => (
                    <Grid container>
                      <Grid size={12} sx={styles1.grid1}>
                        <Grid size={12}>
                          <Stack
                            direction="row"
                            sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
                          >
                            <Typography sx={styles1.Typography2}>투입인원정보</Typography>
                            <Button
                              variant="contained"
                              sx={{ marginLeft: 3, background: 'linear-gradient(180deg, #4A51D5 0%, #2A2E82 98.5%)' }}
                              onClick={() => addWorkerFlagTrue(row.original)}
                            >
                              추가
                            </Button>
                          </Stack>
                        </Grid>
                        <Grid container spacing={2} sx={{ marginTop: 2 }}>
                          <Grid size={6}>
                            {row.original.wkl.length > 0
                              ? row.original.wkl.map((item, index) => {
                                  return (
                                    <Box
                                      key={index}
                                      sx={{
                                        background: '#807F8833',
                                        height: 70,

                                        marginTop: 2,
                                      }}
                                    >
                                      <Grid container sx={{ padding: 1 }}>
                                        <Grid
                                          size={8}
                                          sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
                                        >
                                          {' '}
                                          <Stack
                                            direction="row"
                                            spacing={2}
                                            sx={{
                                              display: 'flex',
                                              justifyContent: 'flex-start',
                                              alignItems: 'center',
                                              marginLeft: 2,
                                              marginTop: 0.5,
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                background: '#2C2D33',
                                                width: 50,
                                                height: 50,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                borderRadius: 50,
                                              }}
                                            >
                                              <img style={{ width: 38, height: 38 }} src={workerIN_worker_1}></img>
                                            </Box>

                                            {item.isFlag === undefined || item.isFlag === false ? (
                                              <>
                                              <Grid container><Grid size={6}></Grid><Grid size={6}></Grid></Grid>
                                                <Stack direction="row">
                                                  {' '}
                                                  <Box
                                                    sx={{
                                                      height: 35,
                                                      borderRadius: '5px',
                                                      background: '#303030',
                                                      display: 'flex',
                                                      justifyContent: 'center',
                                                      alignItems: 'center',
                                                    }}
                                                  >
                                                    <Typography
                                                      sx={{
                                                        width:80,
                                                        fontWeight: 700,
                                                        fontFamily: 'Noto Sans KR',
                                                        fontSize: '10px',
                                                        margin: 1,
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                      }}
                                                    >
                                                      {item.workerName}
                                                    </Typography>
                                                  </Box>
                                                  <Divider
                                                    sx={{
                                                      width: '1px',
                                                      height: 25,
                                                      bgcolor: '#807F88',
                                          marginTop:0.7,
                                          marginLeft:2
                                                    }}
                                                    orientation="vertical"
                                                  />
                                                </Stack>

                                                {item.deviceLists.map((item1, index1) => {
                                                  return (
                                                    <Box
                                                      key={index1}
                                                      sx={{
                                                        height: 32.8,
                                                        borderRadius: '5px',
                                                        background: '#CCCCCC',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                      }}
                                                    >
                                                      <Typography
                                                        sx={{
                                                          color: '#171821',
                                                          fontWeight: 700,
                                                          fontFamily: 'Noto Sans KR',
                                                          fontSize: '10px',
                                                          margin: 1,
                                                        }}
                                                      >
                                                        {item1.device_name}
                                                      </Typography>
                                                    </Box>
                                                  )
                                                })}
                                              </>
                                            ) : (
                                              <Stack
                                                direction="row"
                                                spacing={1}
                                                sx={{
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  alignItems: 'center',
                                                }}
                                              >
                                                {/* 수정mark */}
                                                <Box
                                                  sx={{
                                                    height: 30,
                                                    borderRadius: '5px',
                                                    background: '#CCCCCC',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                  }}
                                                >
                                                  <TextField
                                                    label="근로자명 입력"
                                                    sx={[styles1.Select1, { width: 130 }]}
                                                    value={inputModifyObjectList[findInList2(item)]?.wname}
                                                    onChange={(e) => handelInputWorkerName2(e, item)}
                                                  ></TextField>
                                                </Box>
                                                <FormControl sx={[styles1.Select1]}>
                                                  <InputLabel sx={{ width: '100%' }}>장비선택</InputLabel>
                                                  <Select
                                                    labelId="demo-simple-select-filled-label"
                                                    label="장비선택"
                                                    multiple
                                                    value={inputModifyObjectList[findInList3(item)]?.wdvs}
                                                    onChange={(e) => handleInputDeviceList2(e, item)}
                                                    renderValue={(selected) => selected.join(', ')}
                                                    sx={[styles1.Select1, { width: 200 }]}
                                                  >
                                                    {row.original.deviceLists !== undefined &&
                                                    row.original.deviceLists !== null &&
                                                    row.original.deviceLists !== '' &&
                                                    row.original.hasOwnProperty('deviceLists') ? (
                                                      row.original.deviceLists.map((item1, index) => {
                                                        return (
                                                          <MenuItem key={index} value={item1.di}>
                                                            <Checkbox
                                                              checked={inputModifyObjectList[
                                                                findInList3(item)
                                                              ]?.wdvs?.includes(item1.di)}
                                                            />
                                                            {item1.dname}
                                                          </MenuItem>
                                                        )
                                                      })
                                                    ) : (
                                                      <MenuItem value={null}>{null}</MenuItem>
                                                    )}
                                                  </Select>
                                                </FormControl>
                                              </Stack>
                                            )}

                                            <Divider
                                              sx={{
                                                width: '1px',
                                                height: 25,
                                                bgcolor: '#807F88',
                                              }}
                                              orientation="vertical"
                                            />
                                          </Stack>
                                        </Grid>
                                        <Grid
                                          size={4}
                                          sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
                                        >
                                          {' '}
                                          {item.isFlag !== undefined && item.isFlag === false ? (
                                            <Stack direction="row">
                                              <Button
                                                variant="contained"
                                                sx={{
                                                  fontSize: '12px',
                                                  height: 30,
                                                  color: '#ffffff',
                                                  background: '#807F88',
                                                  marginRight: 2,
                                                }}
                                                onClick={() => deleteWorker(item, row.original)}
                                              >
                                                삭제
                                              </Button>
                                              <Button
                                                variant="contained"
                                                sx={{
                                                  fontSize: '12px',
                                                  height: 30,
                                                  color: '#ffffff',
                                                  background: '#2B2B42',
                                                  marginRight: 2,
                                                }}
                                                onClick={() => modifyWorkerFlagTrue(item, row.original)}
                                              >
                                                수정
                                              </Button>
                                            </Stack>
                                          ) : item.isFlag !== undefined && item.isFlag === true ? (
                                            <>
                                              <Button
                                                variant="contained"
                                                sx={{
                                                  fontSize: '12px',
                                                  height: 30,
                                                  color: '#ffffff',
                                                  background: '#2B2B42',
                                                  marginRight: 2,
                                                }}
                                                onClick={() => patchWorker(item)}
                                              >
                                                수정적용
                                              </Button>
                                              <Button
                                                variant="contained"
                                                sx={{
                                                  fontSize: '12px',
                                                  height: 30,
                                                  color: '#ffffff',
                                                  background: '#807F88',
                                                  marginRight: 2,
                                                }}
                                                onClick={() => modifyWorkerFlagFalse(item, row.original)}
                                              >
                                                수정취소
                                              </Button>
                                            </>
                                          ) : item.isFlag === undefined || item.isFlag === false ? (
                                            <>
                                              <Button
                                                variant="contained"
                                                sx={{
                                                  fontSize: '12px',
                                                  height: 30,
                                                  color: '#ffffff',
                                                  background: '#807F88',
                                                  marginRight: 2,
                                                }}
                                                onClick={() => deleteWorker(item, row.original)}
                                              >
                                                삭제
                                              </Button>
                                              <Button
                                                variant="contained"
                                                sx={{
                                                  fontSize: '12px',
                                                  height: 30,
                                                  color: '#ffffff',
                                                  background: '#2B2B42',
                                                  marginRight: 2,
                                                }}
                                                onClick={() => modifyWorkerFlagTrue(item, row.original)}
                                              >
                                                수정
                                              </Button>
                                            </>
                                          ) : (
                                            ''
                                          )}
                                        </Grid>
                                      </Grid>
                                    </Box>
                                  )
                                })
                              : '등록된 근로자가 없습니다.'}
                          </Grid>
                          <Grid size={6}>
                            {row.original.isFlag !== undefined && row.original.isFlag === true ? (
                              <>
                                <Grid
                                  container
                                  sx={{
                                    padding: 3,
                                    background: '#807F8833',
                                    height: 200,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginTop: 2,
                                  }}
                                >
                                  <Grid size={12}>
                                    <Box>
                                      <Stack
                                        direction="row"
                                        spacing={1}
                                        sx={{
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                        }}
                                      >
                                        {/* mark */}
                                        <Box
                                          sx={{
                                            height: 30,
                                            borderRadius: '5px',
                                            background: '#CCCCCC',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <TextField
                                            label="근로자명 입력"
                                            sx={styles1.Select1}
                                            value={inputObjectList[findInList(row.original)]?.wname}
                                            onChange={(e) => handelInputWorkerName(e, row.original)}
                                          ></TextField>
                                        </Box>
                                        <FormControl sx={[styles1.Select1, { width: '100%' }]}>
                                          <InputLabel sx={{ width: '100%' }}>장비선택</InputLabel>
                                          <Select
                                            labelId="demo-simple-select-filled-label"
                                            label="장비선택"
                                            multiple
                                            value={inputObjectList[findInList(row.original)]?.deviceLists}
                                            onChange={(e) => handleInputDeviceList(e, row.original)}
                                            renderValue={(selected) => selected.join(', ')}
                                            sx={[styles1.Select1, { width: '100%' }]}
                                          >
                                            {row.original.deviceLists !== undefined &&
                                            row.original.deviceLists !== null &&
                                            row.original.deviceLists !== '' &&
                                            row.original.hasOwnProperty('deviceLists') ? (
                                              row.original.deviceLists.map((item, index) => {
                                                return (
                                                  <MenuItem key={index} value={item.di}>
                                                    <Checkbox
                                                      checked={inputObjectList[
                                                        findInList(row.original)
                                                      ]?.deviceLists?.includes(item.di)}
                                                    />
                                                    {item.dname}
                                                  </MenuItem>
                                                )
                                              })
                                            ) : (
                                              <MenuItem value={null}>{null}</MenuItem>
                                            )}
                                          </Select>
                                        </FormControl>
                                      </Stack>
                                    </Box>
                                  </Grid>
                                  <Grid size={12}>
                                    <Button
                                      variant="contained"
                                      sx={{
                                        marginRight: 1,

                                        fontSize: '12px',
                                        height: 30,
                                        color: '#ffffff',
                                        background: '#2B2B42',
                                      }}
                                      onClick={() => addWorker(row.original)}
                                    >
                                      등록
                                    </Button>
                                    <Button
                                      variant="contained"
                                      sx={{
                                        marginLeft: 1,
                                        fontSize: '12px',
                                        height: 30,
                                        color: '#ffffff',
                                        background: '#807F88',
                                      }}
                                      onClick={() => addWorkerFlagFalse(row.original)}
                                    >
                                      취소
                                    </Button>
                                  </Grid>
                                </Grid>
                              </>
                            ) : (
                              ''
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                  mantineTableHeadCellProps={{
                    sx: { color: '#ffffff', backgroundColor: '#2F2E41' },
                    align: 'start',
                  }}
                  mantineTableBodyCellProps={{
                    sx: {
                      color: '#CCCCCC',
                      background:
                        'linear-gradient(to bottom, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
                    },
                    align: 'start',
                  }}
                  mantineDetailPanelProps={{
                    sx: {
                      color: '#ffffff',
                      background:
                        'linear-gradient(to right, rgba(0, 0, 0,0.70), rgba(0, 0, 0)),linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14))',
                    },
                  }}
                  mantineTopToolbarProps={{
                    sx: {
                      color: '#ffffff',
                      background: '#21222D',
                      // mantine-Stack-root
                      '.mantine-Alert-root': {
                        color: '#ffffff',
                        background: '#21222D',
                      },
                      '.mantine-Stack-root': {
                        color: '#ffffff',
                        background: '#21222D',
                      },
                    },
                  }}
                  mantineBottomToolbarProps={{
                    sx: {
                      background: '#21222D',
                      '.mantine-Input-input': {
                        color: '#ffffff',
                        background: '#21222D',
                        borderColor: '#CCCCCC',
                      },
                      '.mantine-InputWrapper-label': {
                        color: '#ffffff',
                        background: '#21222D',
                        borderColor: '#CCCCCC',
                      },
                    },
                  }}
                  mantinePaginationProps={{
                    sx: {
                      background: '#21222D',
                      '.mantine-UnstyledButton-root': {
                        color: '#ffffff',
                        background: '#21222D',
                        borderColor: '#CCCCCC',
                      },
                    },
                  }}
                />
              </>
            )}
          </Box>
        </Grid>
        <Grid size={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button
            variant="contained"
            sx={{
              marginTop: 2,
              background: 'linear-gradient(180deg, #7940CF 0%, #5921CB 100%)',
            }}
            onClick={() => workInput()}
          >
            작업 투입
          </Button>
        </Grid>
      </Grid>
    </div>
  )
}
